(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-result/assets/javascripts/ball-row-result-lotto.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-result/assets/javascripts/ball-row-result-lotto.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.result = svs.tur.ball.row.result || {};
class Lotto extends svs.tur.ball.row.result.Default {
  constructor(options) {
    const numbers = options.numbers,
      extraNumbers = options.extraNumbers;
    options.row = new svs.tur.ball.row.Lotto({
      numbers,
      extraNumbers,
      appendExtraNumbers: true
    });
    super(options);
  }
  classNames() {
    return ['ball-row-result-lotto'];
  }
}
svs.tur.ball.row.result.Lotto = Lotto;

 })(window);